import { AppStore } from 'store/app/types'
import { getInitialLanguage, getUpperCaseLanguage } from 'utils/language.ts'
import { MOVE_FLOWS } from '@boltenergy-be/shared'

export const initialAppState: AppStore = {
  betaMode: false,
  storeLoaded: false,
  language: getUpperCaseLanguage(getInitialLanguage()),
  redirect: null,
  showAllAddresses: false,
  salesSurvey: {
    show: false,
    contractId: null,
    isEligible: false
  },
  error: null,
  urlSearchParams: {},
  move: {
    flow: MOVE_FLOWS.start
  }
}
